import * as actionTypes from '../../types/common';

export const getCountryStates = (data) => async (dispatch) => {
    await dispatch({
        type: actionTypes.GET_COUNTRY_STATES,
        payload: data
    });
};